import Cookies from 'js-cookie'
import Alpine from 'alpinejs'

document.addEventListener('alpine:init', () => {
    Alpine.store('currency', {
        value: null,
        defaultValue: 'EUR',
        init() {
            this.initCurrency()
            const initialValue = this.value
            Alpine.effect(() => {
                if(initialValue !== this.value) {
                    Cookies.set('currency', this.value, { 'expires' : 365, 'path' : '/'})
                }
            })
        },

        initCurrency() {
            let currencyCode = Cookies.get('currency')
            if(window.currencyList.find(c => c.code === currencyCode)) {
                this.value = currencyCode
            } else {
                this.value = this.defaultValue
            }
        },
    })
})

